export const protocol = [
  {
    "title": "",
    "url": "domestic/negligence/2012_11_14 Preliminary Notice Letter-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2012_11_14 Preliminary Notice Letter-2.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2012_11_14 Preliminary Notice Letter-3.jpg"
  }
];
